// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Personal Details Add Start ************************/
export const personalDetailsMember = (verifyData: any) => {
	const data = {
		PersonalDetailsToken: verifyData,
	};
	const url = `${API_URL}personalDetailsMember`;
	return makeApiCall(url, data);
};
/** ***************** Personal Details Add End ************************/
